import { render, staticRenderFns } from "./commonModal.vue?vue&type=template&id=1290bb70&scoped=true&lang=html&"
import script from "./commonModal.vue?vue&type=script&lang=js&"
export * from "./commonModal.vue?vue&type=script&lang=js&"
import style0 from "./commonModal.vue?vue&type=style&index=0&id=1290bb70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1290bb70",
  null
  
)

export default component.exports